import { Box, Typography } from "@mui/material";

const AboutMe = () => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="h5">
        A bit more about me as a software engineer. During freshman year of
        college I took an entrepreneurship class. I really enjoyed the class
        structure, forming a small team and working on a business idea. We did
        things from assessing product market fit, generate a business model, to
        competitor analysis. The class was interesting to me because the product
        I was working on was a problem I personally had. The product was a tool
        to help a client manage their construction project and for workers
        involved to communicate effectively. It allowed clients to be their own
        contractors from finding workers for different jobs to getting real time
        updates from their projects and communicating between all parties. We
        pitched our idea at the schools pitch competition and was a finalist.
        After the class, I was still heavily invested in the idea and especially
        enjoyed talking to customers to provide a better solution. All we had
        was an idea and no technical skills to create a product to test, so I
        wanted to learn to build software products by deciding to study computer
        science.
      </Typography>

      {/* <Typography variant="h4">
        I followed the cs curriculum thinking I would develop my engineering and
        technical skills. What I ended up spending a majority of my time on was
        maintaining my grades. The classes I took was highly theoretical and
        challenging and I wanted to get good grades after all I spent over 20k
        per semester to study here so I did not want to waste my money. I felt
        behind and was afraid to ask for help from peers because I felt dumb and
        inferior to my peers for asking and wanted to be seen as a equal in
        intelligence, working to solve the problem together.
      </Typography> */}
    </Box>
  );
};

export default AboutMe;
